import React, { ChangeEvent, useEffect, useState, } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Header } from '../../../../components/Header';
import { Container, CardContainer, Tabelas, PrimeiraLetra, Tabelas1 } from './styles';
import { Button, Col, Form, Row, Table, Card } from 'react-bootstrap';
import api from '../../../../services/api';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import { ptBR } from 'date-fns/locale';
import TextField from '@mui/material/TextField';
import { useToast } from '../../../../hooks/toast';
import { AxiosError } from 'axios';
import { CotasAssembleia } from '../../../../hooks/cotasAssembleia';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import carro from '../../../../assets/carro.jpg';
import { MdDelete } from 'react-icons/md';
import Switch from '@mui/material/Switch';
import { CotaAssembleia } from '../../../../interfaces/cotaAssembleia';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { FiArrowDown, FiArrowUp } from 'react-icons/fi';
import caminhao from '../../../../assets/caminhao.jpg';
import imovel from '../../../../assets/imovel.jpg';

interface CotaAssembleia2 {
	dataAssembleia: string,
	codigoGrupo: number,
	codigoCota: number,
	tipoLance: string,
	percentualLance: number,
	codigoRepresentante: string,
}

const style = {
	position: 'absolute' as 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 700,
	height: '90%',
	bgcolor: 'background.paper',
	border: 'none',
	boxShadow: 24,
	overflow: 'auto',
	p: 4,
	padding: 2,
};

interface DadosGrupo {
	codigoGrupo: number,
	tiposLance: [
		{
			tipoLance: string,
			lances: [
				{
					id: number,
					dataAssembleia: string,
					percentualLance: number,
					codigoCota: number,
					codigoRepresentante: string,
				}
			]
		}
	]
}


const FormCadastroAssembleia: React.FC = () => {

	const history = useHistory();
	const { id } = useParams() as any
	const { addToast } = useToast();
	const [age, setAge] = React.useState<Date | null>(null);
	const [dataAss, setDataAss] = useState<string>('');
	const { cotasAssembleiaListaCard, getAll, getAllItems, cotasAssembleiaLista, deleteCotas } = CotasAssembleia();
	const [checked, setChecked] = React.useState(false);
	const [openModal, setOpenModal] = useState(false);
	const handleOpenModal = () => setOpenModal(true);
	const handleCloseModal = () => setOpenModal(false);
	const [visible, setVisible] = useState<boolean>(false)
	const [visible2, setVisible2] = useState<boolean>(false)
	const [dadosModal, setDadosModal] = useState<DadosGrupo>();

	function fecharModal(){
		setVisible(false)
		setVisible2(false)
		handleCloseModal()
	}

	function teste2(x: DadosGrupo) {
		x.tiposLance.map(function (item) {
			
		}  )
		x.tiposLance.map(item => item.lances.sort(function(a,b){return a.id > b.id ? -1: a.id < b.id? 1:0}))
		x.tiposLance.map(item => item.lances.sort(function(a,b){return a.percentualLance > b.percentualLance ? -1: a.percentualLance < b.percentualLance? 1:0}))
		setDadosModal(x)
		handleOpenModal()
	}

	useEffect(() => {
		console.log('chegando aqui')
		if (dataAss) {
			console.log('chegando aqui2')
			getAll({dataAssembleiaInicial: dataAss, dataAssembleiaFinal: dataAss, somenteDataLiberada: false})
			getAllItems(dataAss, false)
		}
	}, [dataAss])

	async function deleteCota(id: number){
		await deleteCotas(id)
		getAll({dataAssembleiaInicial: dataAss, dataAssembleiaFinal: dataAss, somenteDataLiberada: false})
		getAllItems(dataAss, false)

			addToast({
				type: 'error',
				title: 'Deletado!',
				description: 'Cota deletada com sucesso!'
			})
	}

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setChecked(event.target.checked);
		console.log({dataAssembleiaInicial: dataAss, dataAssembleiaFinal: dataAss, somenteDataLiberada: false})
	};

	const [model, setModel] = useState<CotaAssembleia2>({
		dataAssembleia: '',
		codigoGrupo: 0,
		codigoCota: 0,
		tipoLance: '',
		percentualLance: 0,
		codigoRepresentante: ''
	})


	function handleChangeInput(e: ChangeEvent<HTMLInputElement>) {
		setModel({
			...model,
			[e.target.name]: e.target.value
		});
	}

	function limpaCampos() {
		console.log(cotasAssembleiaLista)
		setModel({
			...model,
			codigoCota: 0,
			codigoGrupo: 0,
			percentualLance: 0,
			tipoLance: '',
			codigoRepresentante: '',
		})
	}

	async function onSubmit(e: ChangeEvent<HTMLFormElement>) {
		e.preventDefault()
		console.log(model)
		try {
			const response = await api.post('/v2/lances-ofertados-manuais', model)
			console.log(response)
			if (response.status === 201) {
				addToast({
					type: 'success',
					title: 'Dados Salvos',
					description: 'Dados foram salvos com sucesso!'
				})

				limpaCampos()
				getAll({dataAssembleiaInicial: dataAss, dataAssembleiaFinal: dataAss, somenteDataLiberada: false})
				getAllItems(dataAss, false)
			} else {
				addToast({
					type: 'error',
					title: 'Erro ao tentar salvar!',
					description: 'Informe este erro ao TI do consórcio2!'
				})
			}
		} catch (err) {
			const error = err as AxiosError
			let erroMensagem = error.response?.data.developerMessage
			let verificaErro = erroMensagem?.slice(0, 27)
			if (verificaErro === '[Assembleia] não encontrada') {
				addToast({
					type: 'error',
					title: 'Erro data Assembleia!',
					description: 'Data de assembleia não pertence a este grupo, verifique a data!'
				})
			} else {
				addToast({
					type: 'error',
					title: 'Erro ao tentar salvar!',
					description: 'Informe este erro ao TI do consórcio!'
				})
			}

		}
	}

	function adicionaZero(numero: number) {
		if (numero <= 9)
			return "0" + numero;
		else
			return numero;
	}

	function back() {
		history.goBack()
	}

	const handleChangeDate = (newValue: Date | null) => {
		if (newValue != undefined) {
			setAge(newValue)
			console.log(age)
			let DataFormatada = ((adicionaZero(newValue.getFullYear())) + "-" + (adicionaZero(newValue.getMonth() + 1)) + "-" + (adicionaZero(newValue.getDate())))
			let DataFormatada1 = newValue.toLocaleDateString('pt-BR', { timeZone: 'UTC' })
			setModel({ ...model, dataAssembleia: DataFormatada })
			setDataAss(DataFormatada)
		}
	};

	async function teste(){
		const response = await api.post('/v2/lances-ofertados-manuais/importar', { dataAssembleia: dataAss})
		getAll({dataAssembleiaInicial: dataAss, dataAssembleiaFinal: dataAss, somenteDataLiberada: false})
				getAllItems(dataAss, false)
	}

	function ordernarTipoLance(dados:CotaAssembleia[]) {
		const sorteio = dados.filter(item => item.tipoLance==="SORTEIO")
		const livre = dados.filter(item => item.tipoLance==="LIVRE")
		const fixo = dados.filter(item => item.tipoLance==="FIXO")
		const livreOfertado = dados.filter(item => item.tipoLance==="LANCE_OFERTADO_LIVRE")
		const fixoOfertado = dados.filter(item => item.tipoLance==="LANCE_OFERTADO_FIXO")
		const ordenadoFinal = sorteio.concat(livre).concat(fixo).concat(livreOfertado).concat(fixoOfertado)
		console.log('dentro da função de ordenação tipo')
		console.log(ordenadoFinal)

return ordenadoFinal

}


function formatData(x: string) {
	let dataAss = new Date(x)
	let DataFormatada = ((adicionaZero(dataAss.getDate() + 1)) + "/" + (adicionaZero(dataAss.getMonth() + 1)) + "/" + (adicionaZero(dataAss.getFullYear())))
	return (DataFormatada)
}

function leftPad(value: number, totalWidth: number) {
	var length = totalWidth - value.toString().length + 1;
	return Array(length).join('0') + value;
};

function mostrar() {
	setVisible(visible === true ? false : true)
}

function mostrar2() {
	setVisible2(visible2 === true ? false : true)
}

function quebrarLinha(n: number) {
	if (openModal) {
		console.log('ta batendo aqui')
		return (n % 4 === 0)

	}
}


	return (
		<>
			<Header />
			<Container>

				<CardContainer>

					<div className='title'><h2>Cadastro Cota Assembleia</h2></div>
					<Form className="form-border" onSubmit={onSubmit}>
						<Row>
							<Col>
							<LocalizationProvider dateAdapter={AdapterDateFns} locale={ptBR}>
							<DesktopDatePicker
								label="Data da Assembleia"
								inputFormat="dd/MM/yyyy"
								value={age}
								onChange={handleChangeDate}
								className="teste"

								renderInput={(params) => <TextField {...params}
									sx={{ maxWidth: 220, alignItems: "right" }}
								//InputLabelProps={{ shrink: age !== "" ? true : false }}
								/>
								}
							/>
						</LocalizationProvider>
							</Col>
							<Col>
							<div className="buttonsCargo">
							<Button onClick={teste}>Importar Lances Newcon</Button>
							</div>
							
							</Col>
						</Row>
						
						

						<Row style={{ marginTop: 40 }}>
							<Col xs={2}>
								<Form.Group className="inputCargo">
									<Form.Label>Grupo</Form.Label>
									<Form.Control
										style={{ maxWidth: 110 }}
										type="string"
										name="codigoGrupo"
										placeholder="Grupo"
										value={model.codigoGrupo.toString()}
										onChange={(e: ChangeEvent<HTMLInputElement>) => handleChangeInput(e)}
									/>
								</Form.Group>
							</Col>
							<Col xs={2}>
								<Form.Group className="inputCargo">
									<Form.Label>Cota</Form.Label>
									<Form.Control
										style={{ maxWidth: 110 }}
										type="string"
										name="codigoCota"
										placeholder="Cota"
										value={model.codigoCota.toString()}
										onChange={(e: ChangeEvent<HTMLInputElement>) => handleChangeInput(e)}
									/>
								</Form.Group>
							</Col>
							<Col xs={2}>
								<Form.Group className="inputCargo">
									<Form.Label>% Lance</Form.Label>
									<Form.Control
										type="string"
										name="percentualLance"
										placeholder="Percentual Lance"
										value={model.percentualLance}
										onChange={(e: ChangeEvent<HTMLInputElement>) => handleChangeInput(e)}
									/>
								</Form.Group>
							</Col>
							<Col xs={2}>
								<Form.Group className="inputCargo">
									<Form.Label>Representante</Form.Label>
									<Form.Control
										type="string"
										name="codigoRepresentante"
										placeholder="Cód. Representante"
										value={model.codigoRepresentante}
										onChange={(e: ChangeEvent<HTMLInputElement>) => handleChangeInput(e)}
									/>
								</Form.Group>
							</Col>
							<Col xs={4}>
								<Form.Group className="inputCargo">
									<Form.Label>Tipo Contemplação</Form.Label>
									<Form.Control
										as="select"
										value={model.tipoLance}
										name="tipoLance"
										onChange={(e: ChangeEvent<HTMLInputElement>) => handleChangeInput(e)}
										aria-label="Default select example" style={{ maxWidth: 220 }}>
										<option></option>
										<option value="SORTEIO">SORTEIO</option>
										<option value="LIVRE">LIVRE</option>
										<option value="FIXO">FIXO</option>
										<option value="LANCE_OFERTADO_LIVRE">LANCE OFERTADO LIVRE</option>
										<option value="LANCE_OFERTADO_FIXO">LANCE OFERTDADO FIXO</option>
									</Form.Control>
								</Form.Group>
							</Col>
						</Row>
						<Row>
							<Col>
								<div style={{ marginTop: 20 }}>Visualizar Cards</div>
								<Switch
									checked={checked}
									onChange={handleChange}
									inputProps={{ 'aria-label': 'controlled' }}
								/>	</Col>
							<Col><div className="buttonsCargo"><Button onClick={limpaCampos}>Limpar</Button>
								<Button type="submit">Adicionar</Button></div></Col>




						</Row>
					</Form>
					{checked?<>
					<Row>
						{cotasAssembleiaListaCard[0]?.grupos.map(itemGrupo =>
							<Col>
							<Card style={{ width: '13rem', height: '29rem', marginBottom: '10px' }}>
								<Card.Img style={{ width: '206px', height: '110px' }} variant="top" src={itemGrupo.codigoGrupo === 55 ? caminhao : itemGrupo.codigoGrupo === 56 ? imovel : carro} />
								<Card.Body>
									<Card.Title>
										<Typography gutterBottom variant="subtitle2" component="div">
											<Row>
												<Col md={9}>
													Data {formatData(cotasAssembleiaListaCard[0].dataAssembleia)}
												</Col>
												<Col md={3}>
													<div className="btnPesquisar1" onClick={() => teste2(itemGrupo)}>+</div>

												</Col>


											</Row>



										</Typography>

										<Typography gutterBottom variant="h5" component="div">

											GRUPO {itemGrupo.codigoGrupo}
										</Typography>
									</Card.Title>
									<Card.Text>
										{itemGrupo.tiposLance.map(itemTipoContemplacao =>
											(itemTipoContemplacao.tipoLance === "LANCE_OFERTADO_LIVRE" || itemTipoContemplacao.tipoLance === "LANCE_OFERTADO_FIXO") ? <></> :
												<>
													<Typography gutterBottom component="div" style={{ marginTop: '12px' }}>
														{itemTipoContemplacao.tipoLance === "SORTEIO" ? itemTipoContemplacao.tipoLance : `LANCE ` + itemTipoContemplacao.tipoLance}
													</Typography>
													{itemTipoContemplacao.lances.map(itemCotas =>
														<>
															<Typography variant="body2" sx={{ color: 'text.secondary' }}>
																{leftPad(itemCotas.codigoCota, 3)}
																{itemTipoContemplacao.tipoLance === 'SORTEIO' ? '' : ` - ${itemCotas.percentualLance.toFixed(4)}%`}
															</Typography>
														</>
													)}
												</>
										)}
									</Card.Text>

								</Card.Body>
							</Card>
							<div style={{ width: 300, marginLeft: 30 }}>

							</div>
						</Col>

						)}
					</Row>
					</>:<>
					<Tabelas>
						<Table bordered hover className='tabela'>
							<thead>
								<tr>
									<th></th>
									<th>Grupo</th>
									<th>Cota</th>
									<th>Tipo</th>
									<th>Perc.</th>
									<th>Deletar</th>

								</tr>
							</thead>
							<tbody>
								{cotasAssembleiaLista.map((item) =>
									<tr className="linha">
										<td
											className="celula"
											key={item.id}
											id={item.id.toString()}
										>
											<PrimeiraLetra style={{ backgroundColor: `var(--blue)` }}>
												{item.tipoLance.substring(0, 1).toUpperCase()}
											</PrimeiraLetra>
										</td>
										<td>
											{item.codigoGrupo}
										</td>
										<td>
											{item.codigoCota}
										</td>
										<td>
											{item.tipoLance}
										</td>
										<td>
											{item.percentualLance}
										</td>
										<td>
											<td onClick={() => deleteCota(item.id)} className="del"><MdDelete size={20}></MdDelete></td>
										</td>
									</tr>
								)}
							</tbody>
						</Table>
					</Tabelas>
					</>}
				</CardContainer>
			</Container>

			<Modal
							open={openModal}
							onClose={fecharModal}
							aria-labelledby="modal-modal-title"
							aria-describedby="modal-modal-description"
							
						>
							<Box sx={style}>
								<Row>
									<Typography>
										<Tabelas1>
											<div className="titulo title1">
												<Typography style={{ border: "none", margin: "0" }} gutterBottom>
													<h5>RESULTADO DE ASSEMBLEIA</h5>
												</Typography>
											</div>
											<Table bordered responsive className="fonteTI">
												<thead style={{borderRightColor: '#f5f5f5', borderLeftColor: '#f5f5f5' }}>
													<tr>
														<td className="ac70 n tamanhoAC" style={{ backgroundColor: '#f5f5f5', height:'10px' }}>Grupo</td>
														<td className="ac80 n quebraLinha" style={{ backgroundColor: '#f5f5f5', height:'10px' }}>Data de Assembleia</td>
														<td className="ac90 n tamanhoAC" style={{ backgroundColor: '#f5f5f5', height:'10px' }}></td>
														<td className="ac100 n tamanhoAC" style={{ backgroundColor: '#f5f5f5', height:'10px' }}></td>
													</tr>
												</thead>
												<tbody style={{border: '#DEE2E6', borderRightColor: '#ffffff', borderLeftColor: '#ffffff'}}>
													<tr>
														<td className="ac70" style={{ color: "f5f5f5", textAlign: "center", alignItems: "center", verticalAlign: "middle", height: 40 }}>{dadosModal?.codigoGrupo} </td>
														<td className="ac80" style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle" }}>{formatData(dadosModal?.tiposLance[0].lances[0].dataAssembleia || "")}</td>
														<td className="ac90"></td>
														<td className='ac100 quebraLinha' style={{ color: '#ffffff', textAlign: "center", alignItems: "center", verticalAlign: "middle", borderRight: 'none', cursor: 'pointer'  }}>
																	
																			
																			aa
															
																	</td>
													</tr>
												</tbody>
											</Table>
										</Tabelas1>
									</Typography>
								</Row>
			
			
			
			
			
			
			
			
			
			
								<Typography id="modal-modal-description" border={'1px solid red'} sx={{ border: 'none', zIndex: 9999, pad: '0px' }} style={{borderColor:'#fffffff'}}>
									
															{dadosModal?.tiposLance.map(itemTipoContemplacao =>
												(itemTipoContemplacao.tipoLance === "SORTEIO") ?
													<>
														<Tabelas1>
															<Table bordered responsive className="fonteTI" style={{borderBottom: 'solid 1px #DEE2E6'}}>
																<thead style={{borderRightColor: '#f5f5f5', borderLeftColor: '#f5f5f5'}}>
																<tr>
																		<td className="ac70 n" style={{ backgroundColor: '#f5f5f5', height:'10px' }}>Tipo</td>
																		<td className="ac80 n quebraLinha" style={{ backgroundColor: '#f5f5f5' }}>Cotas Contempladas ({itemTipoContemplacao.lances.length})</td>
																		<td className="ac90 n" style={{ backgroundColor: '#f5f5f5', height:'10px' }}>Vendedor</td>												
																		<td className="ac100 n" style={{ backgroundColor: '#f5f5f5', border: '#DEE2E6' }}></td>
																	</tr>
																</thead>
																<tbody style={{border: '#DEE2E6', borderRightColor: '#ffffff', borderLeftColor: '#ffffff'}}>
																	{itemTipoContemplacao.lances.map((itemCotas, index) =>
																	<tr style={{border: "#ffffff"}}>
																		{index===0?<>
																		<td rowSpan={itemTipoContemplacao.lances.length} className="ac70" style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle", height: '10px' }}>{itemTipoContemplacao.tipoLance === "SORTEIO" ? itemTipoContemplacao.tipoLance : `LANCE ` + itemTipoContemplacao.tipoLance} </td>
																		</>:<></>}
																		
																		<td className='ac80' style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle", borderColor: '#ffffff' }}>
																			
																	
																				{leftPad(itemCotas.codigoCota, 3)}
			
											
																			
																		</td>
																		<td className='ac90 quebraLinha' style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle" }}>
																		
																
															
			
																			 {itemCotas.codigoRepresentante}
																		
																	</td>
																	
																	<td className='ac100 quebraLinha' style={{ color: '#ffffff', textAlign: "center", alignItems: "center", verticalAlign: "middle", borderRight: 'none', cursor: 'pointer'  }}>
																	
																			
																			aa
															
																	</td>
																	
																	
																		
																	</tr>
																	)}
																</tbody>
															</Table>
														</Tabelas1>
													</> : <></>
											)}
											{dadosModal?.tiposLance.map(itemTipoContemplacao =>
												(itemTipoContemplacao.tipoLance === "LIVRE") ?
													<>
														<Tabelas1>
															<Table bordered className="fonteTI" style={{borderBottom: 'solid 1px #DEE2E6'}}>
															<thead style={{borderRightColor: '#f5f5f5', borderLeftColor: '#f5f5f5' }}>
																	<tr>
																		<td className="ac70 n" style={{ backgroundColor: '#f5f5f5', border: '#DEE2E6', height:'10px' }}>Tipo</td>
																		<td className="ac80 n" style={{ backgroundColor: '#f5f5f5', border: '#DEE2E6' }}>Cotas Contempladas ({itemTipoContemplacao.lances.length})</td>
																		<td className="ac90 n" style={{ backgroundColor: '#f5f5f5', border: '#DEE2E6' }}>Vendedor</td>
																		<td className="ac100 n" style={{ backgroundColor: '#f5f5f5', border: '#DEE2E6' }}></td>
																	</tr>
																</thead>
																<tbody style={{border: '#DEE2E6', borderRightColor: '#ffffff', borderLeftColor: '#ffffff'}}>
																{itemTipoContemplacao.lances.map((itemCotas, index) =>
																	<tr style={{border: "#ffffff"}} >
																		{index===0?<>
																		<td rowSpan={itemTipoContemplacao.lances.length} className="ac70 tamanhoAC" style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle" }}>{`LANCE ` + itemTipoContemplacao.tipoLance} </td>
																																
																			
																		</>:<></>}
																		
																		<td className='ac80 quebraLinha' style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle", borderRight: 'none'  }}>
																																			
			
																				{leftPad(itemCotas.codigoCota, 3) + " - "}
																				{itemCotas.percentualLance.toFixed(4)}%
																			
																		</td>
																		
																		<td className='ac90 quebraLinha' style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle", borderRight: 'none'  }}>
																														
			
																			 {itemCotas.codigoRepresentante}
			
																		
																	</td>
																	
																	{index===0?<>
																	<td onClick={() => mostrar()} rowSpan={itemTipoContemplacao.lances.length} className='ac100 quebraLinha' style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle", borderRight: 'none', cursor: 'pointer'  }}>
																	
																			
																				{visible ? <FiArrowUp ></FiArrowUp> : <FiArrowDown></FiArrowDown>}
															
																	</td>
																	</>:<></>}
																			
																		
																		
																		
																		
																	</tr>)}
			
																	{visible ? <>
																		{dadosModal?.tiposLance.map(itemTipoContemplacao =>
																		
																			(itemTipoContemplacao.tipoLance === "LANCE_OFERTADO_LIVRE") ?
																				<tr>
																					<td className="tamanhoAC" style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle", borderColor: '#ffffff', marginBottom: 10 }}>{`OFERTADOS `}({itemTipoContemplacao.lances.length})</td>
																					<td colSpan={3} className='quebraLinha' style={{textAlign: "center", alignItems: "center", verticalAlign: "middle", whiteSpace: "pre-wrap", borderColor: '#ffffff' }}>
																						<Row style={{paddingLeft: 10, marginBottom: 10, marginTop: 20}}>
																							<Col sm={1}>
																							</Col>
																							<Col sm={4}>
																							<b>% Lances</b>
																							</Col>
																							<Col sm={6}>
																							<div style={{marginLeft:40}} ><b>Vendedor</b></div>
																							</Col>
																						</Row>
																						
																						{itemTipoContemplacao.lances.map((itemCotas, index) =>
																						<>
																							<Row style={{paddingLeft: 15, borderColor: 'red'}}>
																								<Col sm={1} style={{display: 'grid', placeItems:'center', borderBottom: 'solid 0.5px', borderBottomColor: '#DEE2E6', alignItems: 'right'}} >
																								<div style={{display: 'grid', placeItems:'center', backgroundColor: '#133483', color: '#ffffff', borderRadius: '50%', width:'15px', height: '15px', marginTop: 2, marginBottom: 2, fontSize: 10}}>{leftPad(index + 1, 2)}</div>
																								</Col>
																								
																								<Col sm={4} style={{display: 'grid', placeItems:'center', borderBottom: 'solid 0.5px', borderBottomColor: '#DEE2E6'}}>
																								{itemCotas.percentualLance.toFixed(4)}%
																								</Col>
																								
																								<Col sm={6} style={{ display: 'grid', placeItems:'center', borderBottom: 'solid 0.5px', borderBottomColor: '#DEE2E6'}}>
																								<div style={{marginLeft:40}} >{itemCotas.codigoRepresentante}</div>
																								</Col>
																							</Row>
																							{index===itemTipoContemplacao.lances.length-1?<><div style={{marginTop: '10px'}}></div></>:<></>}
																							
																							
																						</>
																					)}</td><td style={{marginTop: 20}}></td>
																				</tr> : <></>)}</>:<></>}
																		
																				
																</tbody>
															</Table>
														</Tabelas1>
													</> : <></>
											)}
			
											{dadosModal?.tiposLance.map(itemTipoContemplacao =>
												(itemTipoContemplacao.tipoLance === "FIXO") ?
													<>
														<Tabelas1>
															<Table bordered className="fonteTI" style={{width: '100%', borderBottom: 'solid 1px #DEE2E6'}}>
																<thead style={{borderRightColor: '#f5f5f5', borderLeftColor: '#f5f5f5' }}>
																<tr>
																		<td className="ac70 n" style={{ backgroundColor: '#f5f5f5', height:'10px' }}>Tipo</td>
																		<td className="ac80 n" style={{ backgroundColor: '#f5f5f5' }}>Cotas Contempladas ({itemTipoContemplacao.lances.length})</td>
																		<td className="ac90 n" style={{ backgroundColor: '#f5f5f5', border: '#DEE2E6' }}>Vendedor</td>
																		<td className="ac100 n" style={{ backgroundColor: '#f5f5f5', border: '#DEE2E6' }}></td>
																	</tr>
																</thead>
																<tbody style={{border: '#DEE2E6', borderRightColor: '#ffffff', borderLeftColor: '#ffffff'}}>
																	{itemTipoContemplacao.lances.map((itemCotas, index) =>
																	<tr style={{border: "#ffffff"}}>
																	
																		{index===0?<>	
																		<td rowSpan={itemTipoContemplacao.lances.length} className="ac70 tamanhoAC" style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle" }}>{`LANCE ` + itemTipoContemplacao.tipoLance} </td>
																		</>:<></>}
																		<td className='ac80 quebraLinha' style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle" }}>
																	
																			
																			
			
																				{leftPad(itemCotas.codigoCota, 3) + " - "}{itemCotas.percentualLance.toFixed(4)}% 
			
																	
																				
																					
																		
			
																		
																		
																		</td>
																		<td className='ac90 quebraLinha' style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle" }}>
																		{itemCotas.codigoRepresentante}
																		</td>
																		{index===0?<>
																		<td rowSpan={itemTipoContemplacao.lances.length} onClick={() => mostrar2()} className='ac100 quebraLinha' style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle", cursor: 'pointer' }}>
																		{visible2 ? <FiArrowUp></FiArrowUp> : <FiArrowDown></FiArrowDown>}</td>
																		</>:<></>}
																		
																		
																	</tr>
																	)}
																	{visible2 ? <>
																		{dadosModal?.tiposLance.map(itemTipoContemplacao =>
																		(itemTipoContemplacao.tipoLance === "LANCE_OFERTADO_FIXO") ?															
																		<>
												
																	<tr>
																		<td className="tamanhoAC" style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle" }}></td>
																		<td className='quebraLinha' style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle" }}>Quantidade de Ofertas({itemTipoContemplacao.lances.length})</td>
																	</tr>
																	</>:<></>)}</>:<></>}
																</tbody>
															</Table>
														</Tabelas1>
													</> : <></>
											)}
			
											{dadosModal?.tiposLance.map(itemTipoContemplacao =>
												(itemTipoContemplacao.tipoLance === "LANCE_OFERTADO_LIVREwee") ?
													<>
														<Tabelas1>
															<Table bordered hover responsive className="fonteTI">
																<thead style={{borderRightColor: '#f5f5f5', borderLeftColor: '#f5f5f5' }}>
																	<tr style={{height:10}}>
																		<td className="ac n tamanhoAC" style={{ backgroundColor: '#f5f5f5', height:'10px' }}>Tipo</td>
																		<td className="ac n" style={{ backgroundColor: '#f5f5f5' }}>Lances livre ofertados ({itemTipoContemplacao.lances.length})</td>
																		<td className="ac tam" style={{ backgroundColor: '#f5f5f5', cursor: 'pointer' }} onClick={() => mostrar()}>{visible ? <FiArrowUp></FiArrowUp> : <FiArrowDown></FiArrowDown>}</td>
																	</tr>
																</thead>
																<tbody style={{border: '#DEE2E6', borderRightColor: '#ffffff', borderLeftColor: '#ffffff'}}>
																	{visible ? <>
																		<tr>
																			<td className="tamanhoAC" style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle" }}>{`LANCE ` + itemTipoContemplacao.tipoLance === "LANCE_OFERTADO_LIVRE" ? "LANCE LIVRE" : "LANCE LIVRE"} </td>
																			<td className='quebraLinha' style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle", whiteSpace: "pre-wrap" }}>{itemTipoContemplacao.lances.map((itemCotas, index) =>
																				<>
			
																					{leftPad(index + 1, 3) + " - "}
																					{itemCotas.percentualLance.toFixed(4)}% {itemTipoContemplacao.lances.length === index + 1 ? '' : quebrarLinha(index + 1) === true ? <br /> : ', '}
																				</>
																			)}</td>
																		</tr>
			
																	</> : <></>}
			
																</tbody>
															</Table>
														</Tabelas1>
													</> : <></>
											)}
			
											{dadosModal?.tiposLance.map(itemTipoContemplacao =>
												(itemTipoContemplacao.tipoLance === "LANCE_OFERTADO_FIXOeerr") ?
													<>
			
														<Tabelas1>
															<Table bordered hover responsive className="fonteTI">
																<thead style={{borderRightColor: '#f5f5f5', borderLeftColor: '#f5f5f5' }}>
																	<tr>
																		<td className="ac n tamanhoAC" style={{ backgroundColor: '#f5f5f5', height:'10px' }}>Tipo</td>
																		<td className="ac n" style={{ backgroundColor: '#f5f5f5' }}>Lances fixo ofertados ({itemTipoContemplacao.lances.length})</td>
																	</tr>
																</thead>
																<tbody style={{border: '#DEE2E6', borderRightColor: '#ffffff', borderLeftColor: '#ffffff'}}>
																	<tr>
																		<td className="tamanhoAC" style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle" }}>{`LANCE FIXO`} </td>
																		<td style={{ textAlign: "center", alignItems: "center", verticalAlign: "middle" }}>
																			{itemTipoContemplacao.lances.length} LANCES OFERTADOS	</td>
																	</tr>
																</tbody>
															</Table>
														</Tabelas1>
			
													</> : <></>
											)}
			
			
			
			
										
			
									
									<Form.Group style={{ display: 'flex', marginTop: '30px', justifyContent: 'flex-end' }} className="buttonsCargo">
										<Button style={{ backgroundColor: 'var(--blue)' }} onClick={fecharModal}>Fechar</Button>
									</Form.Group>
			
								</Typography>
							</Box>
						</Modal>


		</>
	)
}

export default FormCadastroAssembleia